export const seatStatuses = {
  8350: true,
  8351: true,
  8352: true,
  8353: true,
  8354: true,
  8355: true,
  8356: true,
  8357: true,
  8358: true,
  8359: true,
  8360: false,
  8361: false,
  8362: false,
  8363: false,
  8364: false,
  8365: true,
  8366: true,
  8367: true,
  8368: true,
  8369: false,
  8370: false,
  8430: true,
  8431: true,
  8432: true,
  8433: true,
  8434: true,
  8435: true,
  8436: true,
  8437: true,
  8438: true,
  8439: true,
  8440: true,
  8441: true,
  8442: true,
  8443: true,
  8444: true,
  8445: true,
  8446: true,
  8447: true,
  8448: true,
  8449: false,
  8450: false,
  8510: true,
  8511: true,
  8512: true,
  8513: false,
  8514: true,
  8515: false,
  8516: false,
  8517: false,
  8518: true,
  8519: true,
  8520: true,
  8521: true,
  8522: true,
  8523: true,
  8524: true,
  8525: true,
  8526: true,
  8527: true,
  8528: true,
  8529: true,
  8530: true,
  8590: true,
  8591: true,
  8592: false,
  8593: false,
  8594: false,
  8595: true,
  8596: false,
  8597: false,
  8598: false,
  8599: true,
  8600: true,
  8601: true,
  8602: true,
  8603: true,
  8604: true,
  8605: true,
  8606: true,
  8607: true,
  8608: true,
  8609: true,
  8610: true,
  8670: true,
  8671: true,
  8672: true,
  8673: true,
  8674: true,
  8675: true,
  8676: true,
  8677: true,
  8678: true,
  8679: true,
  8680: true,
  8681: true,
  8682: true,
  8683: true,
  8684: true,
  8685: true,
  8686: true,
  8687: true,
  8688: true,
  8689: true,
  8690: true,
  8750: true,
  8751: true,
  8752: true,
  8753: true,
  8754: true,
  8755: true,
  8756: true,
  8757: true,
  8758: true,
  8759: true,
  8760: true,
  8761: true,
  8762: true,
  8763: true,
  8764: true,
  8765: true,
  8766: true,
  8767: true,
  8768: true,
  8769: true,
  8770: true
};
